import { widgetFormAdvancedRadio } from '../WidgetFormAdvancedRadio';
import { widgetFormAltcha } from '../WidgetFormAltcha';
import { widgetFormArcgisAddress } from '../WidgetFormArcgisAddress';
import { widgetFormButton } from '../WidgetFormButton';
import { widgetFormCheckbox } from '../WidgetFormCheckbox';
import { widgetFormCheckboxList } from '../WidgetFormCheckboxList';
import { widgetFormColorGradientPicker } from '../WidgetFormColorGradientPicker';
import { widgetFormColorPicker } from '../WidgetFormColorPicker';
import { widgetFormContent } from '../WidgetFormContent';
import { widgetFormDataGrid } from '../WidgetFormDataGrid';
import { widgetFormDate } from '../WidgetFormDate';
import { widgetFormDatePicker } from '../WidgetFormDatePicker';
import { widgetFormDateRangePicker } from '../WidgetFormDateRangePicker';
import { widgetFormDateTimePicker } from '../WidgetFormDateTimePicker';
import { widgetFormDateTimeRangePicker } from '../WidgetFormDateTimeRangePicker';
import { widgetFormDivider } from '../WidgetFormDivider';
import { widgetFormEmail } from '../WidgetFormEmail';
import { widgetFormErrors } from '../WidgetFormErrors';
import { widgetFormFile } from '../WidgetFormFile';
import { widgetFormGoogleReCaptchaV2 } from '../WidgetFormGoogleReCaptchaV2';
import { widgetFormHtml } from '../WidgetFormHtml';
import { widgetFormIconPicker } from '../WidgetFormIconPicker';
import { widgetFormImage } from '../WidgetFormImage';
import { widgetFormLabel } from '../WidgetFormLabel';
import { widgetFormModalPanel } from '../WidgetFormModalPanel';
import { widgetFormModalPanelList } from '../WidgetFormModalPanelList';
import { widgetFormModalRowList } from '../WidgetFormModalRowList';
import { widgetFormMultiSelect } from '../WidgetFormMultiSelect';
import { widgetFormNumber } from '../WidgetFormNumber';
import { widgetFormPanel } from '../WidgetFormPanel';
import { widgetFormPassword } from '../WidgetFormPassword';
import { widgetFormPhone } from '../WidgetFormPhone';
import { widgetFormRadio } from '../WidgetFormRadio';
import { widgetFormRadioIcon } from '../WidgetFormRadioIcon';
import { widgetFormRichTextEditor } from '../WidgetFormRichTextEditor';
import { widgetFormSelect } from '../WidgetFormSelect';
import { widgetFormSubForm } from '../WidgetFormSubForm';
import { widgetFormTableView } from '../WidgetFormTableView';
import { widgetFormTabs } from '../WidgetFormTabs';
import { widgetFormTemplate } from '../WidgetFormTemplate';
import { widgetFormText } from '../WidgetFormText';
import { widgetFormTimePicker } from '../WidgetFormTimePicker';
import { widgetFormTimePickerV2 } from '../WidgetFormTimePickerV2';
import { widgetFormUsSsn } from '../WidgetFormUsSsn';
import { widgetFormYesNo } from '../WidgetFormYesNo';
import { widgetForm } from './widgetForm';
export * from './types';
export * from './widgetForm';
export const defaultFormWidgets = [
    widgetForm,
    // begin, keep this list sorted alphabetically
    widgetFormAdvancedRadio,
    widgetFormAltcha,
    widgetFormArcgisAddress,
    widgetFormButton,
    widgetFormCheckbox,
    widgetFormCheckboxList,
    widgetFormColorGradientPicker,
    widgetFormColorPicker,
    widgetFormContent,
    widgetFormDataGrid,
    widgetFormDate,
    widgetFormDatePicker,
    widgetFormDateRangePicker,
    widgetFormDateTimePicker,
    widgetFormDateTimeRangePicker,
    widgetFormDivider,
    widgetFormEmail,
    widgetFormErrors,
    widgetFormFile,
    widgetFormGoogleReCaptchaV2,
    widgetFormHtml,
    widgetFormIconPicker,
    widgetFormImage,
    widgetFormLabel,
    widgetFormModalPanel,
    widgetFormModalPanelList,
    widgetFormModalRowList,
    widgetFormMultiSelect,
    widgetFormNumber,
    widgetFormPanel,
    widgetFormPassword,
    widgetFormPhone,
    widgetFormRadio,
    widgetFormRadioIcon,
    widgetFormRichTextEditor,
    widgetFormSelect,
    widgetFormSubForm,
    widgetFormTableView,
    widgetFormTabs,
    widgetFormTemplate,
    widgetFormText,
    widgetFormTimePicker,
    widgetFormTimePickerV2,
    widgetFormUsSsn,
    widgetFormYesNo,
    // end, keep this list sorted alphabetically
];
